// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"e100f37c","815":"9bff1c3f","920":"e100f37c"}[chunkId] + ".chunk.css";
};